var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/**
 * Create date-time formatter
 * @param options = {
            timeZoneName: 'short',
            weekday: undefined,
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            hour12: false,
        };
 */
var dateFormatter = function (options) { return function (params) {
    if (!params)
        return "";
    return params.value !== undefined
        ? params.value
            ? new Date(params.value).toLocaleString("en-US", options)
            : ""
        : new Date(params).toLocaleString("en-US", options);
}; };
export var asInputDateString = function (date) {
    return date.toISOString().substring(0, 10);
};
export var asTimelessDate = function (params) {
    if (!params)
        return "";
    return params.value !== undefined
        ? params.value
            ? timelessUTCDate(params.value)
            : ""
        : timelessUTCDate(params);
};
var timelessUTCDate = function (params) {
    return (params.getUTCMonth() +
        1 +
        "/" +
        params.getUTCDate() +
        "/" +
        params.getUTCFullYear());
};
export var asTimelessDateUTC = function (params) {
    if (!params)
        return "";
    return params.value !== undefined
        ? params.value
            ? timelessUTCDate(new Date(params.value))
            : ""
        : timelessUTCDate(new Date(params));
};
export var asDate = dateFormatter({
    year: "numeric",
    month: "numeric",
    day: "numeric"
});
export var asDateTime = dateFormatter({
    timeZoneName: "short",
    weekday: undefined,
    year: "numeric",
    month: "numeric",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false
});
export var asDateTimeUTC = dateFormatter({
    year: "numeric",
    month: "numeric",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    timeZone: 'UTC',
    hour12: true
});
export var asFilenameDateTime = dateFormatter({
    year: "numeric",
    month: "numeric",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: '2-digit',
    hour12: false
});
export var asTime = dateFormatter({
    timeZoneName: "short",
    hour: "2-digit",
    minute: "2-digit",
    hourCycle: "h23"
});
export function asCurrency(params, currency, options) {
    if (currency === void 0) { currency = 'USD'; }
    if (options === void 0) { options = {}; }
    currency = currency || 'USD';
    var x = extractParams(params);
    if (!isNaN(x) && x !== null && x !== undefined) {
        try {
            return x.toLocaleString("en-US", __assign({ style: "currency", currency: currency }, options));
        }
        catch (_a) {
            return currency + " " + x;
        }
    }
    return "";
}
export function asShortCurrency(x, currency) {
    if (currency === void 0) { currency = 'USD'; }
    return asCurrency(x, currency, { notation: 'compact' });
}
export function asPercent(value) {
    return String(Math.round(value * 100)) + "%";
}
export function getPercentValue(part, full) {
    return Math.round((part / full) * 100) || 0;
}
function extractParams(params) {
    return params == null || params.value === undefined ? params : params.value;
}
export function csvHyperlink(url) {
    return '=HYPERLINK(""' + url + '"")';
}
export var handleDateStringWithoutTimeZoneInfo = function (dateString) {
    if (typeof dateString !== "string") {
        return dateString;
    }
    var utcDateString = dateString + "Z";
    var date = new Date(utcDateString);
    if (isNaN(date.getTime())) {
        // Date string is not in a recognized format meaning it is either an invalid date or already has timezone information on it, return the string as-is
        return dateString;
    }
    // Date string is now a recognized UTC format, convert to UTC date string
    return date.toISOString();
};
export var handleDate = function (date) {
    return !!date ? new Date(asTimelessDateUTC(date)) : null;
};
export var getDateOnly = function (date) {
    if (!date) {
        return null;
    }
    var year = date.getFullYear();
    var month = String(date.getMonth() + 1).padStart(2, "0");
    var day = String(date.getDate()).padStart(2, "0");
    return year + "-" + month + "-" + day;
};
//# sourceMappingURL=formatters.js.map